import StatusTrackerPageContainer from './StatusTrackerPageContainer';

export default StatusTrackerPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/StatusTrackerPage/index.js